import { useRestoreScrollPosition } from './useRestoreScrollPosition';
import { useSaveScrollPosition } from './useSaveScrollPosition';

export const useRestoreScroll = () => {
  useSaveScrollPosition();
  useRestoreScrollPosition();
};
